import { type Room } from "matrix-js-sdk/src/matrix";
import React from "react";

import { _t } from "../languageHandler";
import { MatrixClientPeg } from "../MatrixClientPeg";
// import SettingsStore from "../settings/SettingsStore";
import RoomProvider from "./RoomProvider";

export default class SpaceProvider extends RoomProvider {
    protected getRooms(): Room[] {
        //.getVisibleRooms(SettingsStore.getValue("feature_dynamic_room_predecessors"))
        return MatrixClientPeg.safeGet().getVisibleRooms(false)
            .filter((r) => r.isSpaceRoom());
    }

    public getName(): string {
        return _t("common.spaces");
    }

    public renderCompletions(completions: React.ReactNode[]): React.ReactNode {
        return (
            <div
                className="mx_Autocomplete_Completion_container_pill mx_Autocomplete_Completion_container_truncate"
                role="listbox"
                aria-label={_t("composer.autocomplete.space_a11y")}
            >
                {completions}
            </div>
        );
    }
}
